import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import { TStyledTypographyProps } from './Typography.types';

export const STypography = styled(Typography)<TStyledTypographyProps>`
  font-size: ${({ $fontSize }) => $fontSize || ''};
  font-weight: ${({ $fontWeight }) => $fontWeight || ''};
`;
